var Layer       = require("./Layer"),
    OmsSource   = require("./OmsSource"),
    ol          = require('openlayers');


var TileLayer = Layer.extend({

    initialize: function(options){
        var that = this;
        TileLayer.__super__.initialize.call(that, options);

        that._olLayer = new ol.layer.Tile({
            'visible': options.visible
        });

        that._setup(options);
    },

    _setup: function(options){
        var that = this;

        options || (options = {});

        if ('projectLayers' in options) {
            that._prjLayers = options.projectLayers;
        }

        //...
        if (that._prjLayers && that._prjLayers.getLength() > 0) {
            that._olSource = new OmsSource({
                crossOrigin: "anonymous",
                layers: that._prjLayers.pluck('map_layer_id'),
                urlTemplate: that.options.urlTemplate,
                mapCode: that.options.mapCode,
                tilesQuality: that.options.tilesQuality-1
            });

            that._olLayer.setSource(that._olSource);

            if (that.options['activeLayers']) {
                that.setActiveLayers(that.options['activeLayers']);
            } else {
                that.fire('activeLayersChange', {
                    layerIds: that._prjLayers.pluck('map_layer_id')
                });
            }
        }

        return that;
    },

    updateLayer: function() {
        var that = this;
        that._olSource.update();
    },

    setActiveLayers: function(codes) {
        var that = this,
            layersForActivation,
            layerIds;

        layersForActivation = that._prjLayers.filter(function(l){
            return ~codes.indexOf(l.get('code')) != 0;
        });

        layerIds = layersForActivation.pluck('map_layer_id');

        that.getMapLayer()
            .getSource()
            .setActiveLayers(layerIds);

        that.fire('activeLayersChange', {
            layerIds: layerIds
        });
    },

    activateLayers: function(codes) {
        var that = this,
            source = that.getMapLayer().getSource(),
            layersForActivation,
            layerIds;

        if (source) {
            layersForActivation = that._prjLayers.filter(function(l){
                return ~codes.indexOf(l.get('code')) != 0;
            });
            layerIds = layersForActivation.pluck('map_layer_id');
            layerIds = _.union(source.getActiveLayers(),layerIds);

            that.getMapLayer()
                .getSource()
                .setActiveLayers(layerIds);

            that.fire('activeLayersChange', {
                layerIds: layerIds
            });
        }
    },

    deactivateLayers: function(codes) {
        var that = this,
            source = that.getMapLayer().getSource(),
            layersForActivation,
            layerIds;

        if (source) {
            layersForActivation = that._prjLayers.filter(function(l){
                return ~codes.indexOf(l.get('code')) != 0;
            });
            layerIds = layersForActivation.pluck('map_layer_id');
            layerIds = _.difference(source.getActiveLayers(),layerIds);

            source.setActiveLayers(layerIds);

            that.fire('activeLayersChange', {
                layerIds: layerIds
            });
        }
    },

    getActiveLayerCodes : function() {
        var that = this,
            activeIds;
        activeIds = that._olSource.getActiveLayers();

        return that._prjLayers.filter(function(l){
            return ~activeIds.indexOf(l.get('map_layer_id')) != 0;
        }).getArray().map(function(l){
            return l.get('code');
        });
    },

    syncWithProject: function(without) {
        var that = this;
        var layersForActivation;
        var oldActiveLayersHash;
        var layersForActivationHash;
        var source = that.getSource();

        if (source) {
            oldActiveLayersHash = [].concat(source.getActiveLayers()).sort(function(a, b) {
                return a - b;
            }).join(' ');

            layersForActivation = that._prjLayers.filter(function(l) {
                var res = l.get('selected');
                if (without) {
                    if (~without.indexOf(l.get('code'))) {
                        res = ~source.getActiveLayers().indexOf(l.get('id'));
                    }
                }
                return res;
            }).pluck('id');

            layersForActivationHash = [].concat(layersForActivation).sort(function(a, b) {
                return a - b;
            }).join(' ');

            if (oldActiveLayersHash !== layersForActivationHash) {
                source.setActiveLayers(layersForActivation);
            }

            return {
                changes: oldActiveLayersHash !== layersForActivationHash,
                oldLayers: oldActiveLayersHash !== "" ? oldActiveLayersHash.split(' ') : [],
                newLayers: layersForActivationHash !== "" ? layersForActivationHash.split(' ') : []
            };
        }
    }
});

module.exports = TileLayer;



//////////////////
// WEBPACK FOOTER
// ./src/View/TileLayer.js
// module id = 42
// module chunks = 0